import "./css/menu-tertiary-item.css";

export default function menuTertiaryItem(props) {
  const isExternalClass = props?.isExternal
    ? "menu-tertiary-item--external"
    : "";
  const isActiveClass = props?.isActive ? "menu-primary-item--active" : "";
  const classList = [
    "menu-tertiary-item",
    `menu-tertiary-item--${props.type}`,
    isActiveClass,
    isExternalClass,
  ]
    .filter((item) => !!item)
    .join(" ");

  return (
    <li className={classList}>
      <a href={props?.url ?? "#"} className="menu-tertiary-item__link">
        {props?.label}
      </a>
    </li>
  );
}
